import { Route } from '@angular/router';

import { LoginComponent } from './login.component';
import { ExternalLoginComponent } from './external-login/external-login.component';
import { PartnerLoginComponent } from './partner-login/partner-login.component';

export const loginRoutes: Array<Route> = [
  {
    path: 'login/external',
    component: ExternalLoginComponent
  },
  {
    path: 'login/partner',
    component: PartnerLoginComponent
  },
  {
    path: 'login/:companyId/:username',
    component: LoginComponent
  },
  {
    path: 'login/:username',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  }
];
